import { cn } from "./ui/utils";

export function ChangePctCell({ value }: { value: number | null }) {
  if (value === null || value === undefined) {
    return <span className="text-muted-foreground">-</span>;
  }
  const sign = value > 0 ? "+" : "";
  const color = value > 0 ? "text-green-600" : value < 0 ? "text-red-600" : "text-muted-foreground";
  return <span className={cn("tabular-nums", color)}>{sign}{value.toFixed(1)}%</span>;
}
